import { render, staticRenderFns } from "./TeamsPage.vue?vue&type=template&id=60c4e4c6"
import script from "./TeamsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamsPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60c4e4c6')) {
      api.createRecord('60c4e4c6', component.options)
    } else {
      api.reload('60c4e4c6', component.options)
    }
    module.hot.accept("./TeamsPage.vue?vue&type=template&id=60c4e4c6", function () {
      api.rerender('60c4e4c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/pages/client/teams/TeamsPage.vue"
export default component.exports